module.exports = __webpack_public_path__ + "img/tk.b4fbd870.svg";